import * as React from "react";
import {Fragment} from "react";
import JobStatusNotification from "../../../model/notification/job/JobStatusNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobStatusNotification
}

/**
 * Job status notification toast body.
 */
const NotificationJobStatusBody: React.SFC<ComponentProps> = (props) => {
	const currentStatusLabel = props.notification.getCurrentStatusLabel();
	const previousStatusLabel = props.notification.getPreviousStatusLabel();
	return (
		<Fragment>
			<div className={"toast-header"}>Job {props.notification.data.referenceNumber}</div>
			<div className={"toast-body"}>
				Status changed
				{previousStatusLabel.isDefined && <div>
					from:<br/>
					<b>{previousStatusLabel.get}</b>
				</div>}
				{currentStatusLabel.isDefined && <div>
					to:<br/>
					<b>{currentStatusLabel.get}</b>
				</div>}
			</div>
		</Fragment>
	);
};

export default NotificationJobStatusBody;